<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>异常派车</h4>
    </div>
    <el-tabs v-model="activeName" style="margin-left:10px;" type="card" @tab-click="handleClick">
    <el-tab-pane label="备案车辆" name="first">
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom1" ref="searchFrom1" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="车牌号:" prop="vehicleNo">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom1.vehicleNo"></el-input>
          </el-form-item>
          <el-form-item label="疏港计划号:" prop="planNo">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom1.planNo"></el-input>
          </el-form-item>
          <el-form-item label="作业码头:" prop="wharfCode">
            <el-select v-model="searchFrom1.wharfCode" placeholder="请选择">
              <el-option
                v-for="(item,index) in wharfOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车队:" prop="fleetId">
            <el-select v-model="searchFrom1.fleetId" placeholder="请选择">
              <el-option
                v-for="(item,index) in fleetOptions"
                :key="index"
                :label="item.fleetName"
                :value="item.fleet">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='001P009B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='001P009B002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableDate"
        ref="table"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        @row-click = 'handleRowClick2'
        highlight-current-row>
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="sendcarFlag"    label="异常状态" align="center" ></el-table-column>
        <el-table-column prop="planNo"   label="疏港计划号" align="center" ></el-table-column>
        <el-table-column prop="wharfCode"   label="作业码头" align="center" ></el-table-column>
        <el-table-column property="vehicleNo" label="车牌号"  align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fleetName"    label="车队" align="center" ></el-table-column>
        <el-table-column prop="driverName" label="司机" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="driverMobile"    label="电话"   align="center" ></el-table-column>
        <el-table-column prop="sendcatTime"    label="派车时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sendcarUser"  label="派车人" align="center"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom1.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    </el-tab-pane>
    <!--非备案车辆-->
    <el-tab-pane label="非备案车辆" name="second">
      <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="heTongFrom" ref="heTongFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="车牌号:" prop="vehicleNo">
            <el-input  placeholder="" maxlength="100" v-model="heTongFrom.vehicleNo"></el-input>
          </el-form-item>
          <el-form-item label="疏港计划号:" prop="planNo">
            <el-input  placeholder="" maxlength="100" v-model="heTongFrom.planNo"></el-input>
          </el-form-item>
          <el-form-item label="车队:" prop="fleetId">
            <el-select v-model="heTongFrom.fleetId" placeholder="请选择">
              <el-option
                v-for="(item,index) in fleetOptions"
                :key="index"
                :label="item.fleetName"
                :value="item.fleet">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="派车时间:" prop="startTime">
            <el-date-picker
              v-model="heTongFrom.startTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="heTongFrom.endTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item>
          <el-button type="primary"  @click="cheXiaoSearch" btnCode='001P009B003' v-if="btnFlg[2]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  @click="cheXiaoChongZhi" btnCode='001P009B004' v-if="btnFlg[3]">重置</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoadingB'>
      <el-table
        :data="shenHeTableList"
        ref="cheXiaoShenHeTab"
        @row-click = 'handleRowClick'
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="planNo"    label="疏港计划号" align="center" ></el-table-column>
        <el-table-column prop="wharfCode"   label="作业码头" align="center" ></el-table-column>
        <el-table-column property="vehicleNo" label="车牌号"  align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="fleetName"    label="车队" align="center" ></el-table-column>
        <el-table-column prop="driverName"   label="司机" align="center" ></el-table-column>
        <el-table-column prop="driverMobile"  label="电话" align="center" ></el-table-column>
        <el-table-column prop="sendcatTime"    label="派车时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sendcarUser"    label="派车人"   align="center" ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="heTongFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="heTongFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1">
      </el-pagination>
    </div>
    </el-tab-pane>
  </el-tabs>

  </div>
</template>
<script>
import {
  fleetList,
  getDictionaryList, // 字典
  getAbnormalCarDataList, // 备案列表查询
  getNonAbnormalCarDataList, // 非备案列表查询
  cheXiaoShenHe, // 撤销审核数据
  shenHeAuditFlag // 审核通过/不通过
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P009B001', '001P009B002', '001P009B003',
        '001P009B004'],
      activeName: 'first',
      title: '',
      h: '500px',
      total: 0,
      searchFrom1: {
        pageNo: 1,
        pageSize: 10,
        fleetId:'',
        wharfCode:''
      },
      wharfOptions: [],
      // 车队
      fleetOptions: [],
      value: '',
      tableDate: [],
      shenHeTableList: [],
      // 查看
      xiangQingData: [],
      heTongFrom: {
        pageNo: 1,
        pageSize: 10,
        fleetId:'',
      },
      total1: 0,
      // 审核状态
      shenHeOptions: [{
        value: '0',
        label: '待审核'
      }, {
        value: '1',
        label: '审核不通过'
      }, {
        value: '2',
        label: '审核通过'
      }],
      auditFlag: '', // 判断审核状态
      yunDanId: '', // 运单id
      mingXiFrom: {

      },
      waybillStatus: '',
      waybillId: '',
      tabLoading:false,
      tabLoadingB:false
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.fleetOptionsInit()
    this.getDictionaryList()
    // this.getToDay()
    this.getSearctData(this.searchFrom1)
    this.btnFlg = getBtn(this.btnIdArr, '/sendCars/abnormalSendCars')
  },
  methods: {
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({'fleet':'','fleetName':'全部'})
      })
    },
    // 字典
    getDictionaryList(){
      getDictionaryList({
        groupNo:'wharf_1'
      }).then(res =>{
        this.wharfOptions = res.wharf_1
        this.wharfOptions.unshift({'itemNo':'','showName':'全部'})
      }).catch(err =>{
        DonMessage.error(err.message);
      })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      let dateEndStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      // console.log(dateEndStr)
      // console.log((new Date()).getTime(),'22222')  //当前时间戳
      let nowDate = (new Date()).getTime()
      // console.log(new Date(dateStartStr).getTime(),'333')   // 早八点时间戳
      let morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) {
        this.searchFrom1.sendcatTimeShow = this.timeStamp(new Date())
        // console.log(this.searchFrom1.sendcatTimeShow, '2222')
        this.heTongFrom.sendcatTimeShow = this.timeStamp(new Date())
        // console.log(this.heTongFrom.sendcatTimeShow, '333')
      } else {
        // 昨天的时间
        var day1 = new Date()
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
        var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
        // console.log(s1,'00000000')
        this.searchFrom1.sendcatTimeShow = s1
        this.heTongFrom.sendcatTimeShow = s1
      }
    },
    // 获取备案车辆数据
    getSearctData () {
      this.tabLoading = true
      getAbnormalCarDataList(this.searchFrom1).then(res => {
        this.tabLoading = false
        this.tableDate = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        this.$message.error(err.message)
      })
    },
    // 获取撤销审核数据
    getCheXiaoData () {
      this.tabLoadingB = true
      getNonAbnormalCarDataList(this.heTongFrom).then(res => {
        this.tabLoadingB = false
        this.shenHeTableList = res.list
        this.total1 = res.total
      }).catch(err => {
        this.tabLoadingB = false
        this.$message.error(err.message)
      })
    },
    // 点击运单查询按钮
    searchClick () {
      this.getSearctData(this.searchFrom1)
    },
    // 点击运单重置按钮
    chongZhiClick () {
      this.searchFrom1 = {
        pageNo: 1,
        pageSize: 10,
        fleetId:'',
        wharfCode:''
      }
      this.getSearctData(this.searchFrom1)
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getSearctData(this.searchFrom1)
      } else if (tab.index == 1) {
        this.getCheXiaoData(this.heTongFrom)
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom1.pageSize = val
      this.getSearctData(this.searchFrom1)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom1.pageNo = val
      this.getSearctData(this.searchFrom1)
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      this.getCheXiaoData(this.heTongFrom)
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      this.getCheXiaoData(this.heTongFrom)
    },
    // 撤销审核查询
    cheXiaoSearch () {
      this.getCheXiaoData(this.heTongFrom)
    },
    // 撤销审核重置
    cheXiaoChongZhi () {
      this.heTongFrom = {
        pageNo: 1,
        pageSize: 10,
        fleetId:'',
      }
      this.getCheXiaoData(this.heTongFrom)
    },
    // 点击每行数据触发事件
    handleRowClick (row) {
      // console.log(row)
      this.$refs.cheXiaoShenHeTab.toggleRowSelection(row)
      this.auditFlag = row.auditFlag
      this.yunDanId = row.id
    },
    // 运单点击每行
    handleRowClick2 (row) {
      this.$refs.table.toggleRowSelection(row)
      this.waybillId = row.id
      this.waybillStatus = row.waybillStatus
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#0c46a2;
  color: #fff;
}

.inpBox{
  margin: 10px 0 0 -30px;
}
// .inpBox .el-date-editor{
//     width: 220px!important;
//  }
//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width:  150px;
}
.searchBtnBox{
  margin-top: 10px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
